import React from 'react';
import { Button, Card, CardContent, MenuItem, Stack, TextField, Typography } from '@mui/material';

import { APPROVAL_TYPES } from './approvalWorkflowConstants';

export default function ApprovalCreateCard({ form, onFormChange, onSubmit }) {
    return (
        <Card component="form" onSubmit={onSubmit}>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Neue Freigabe anlegen
                </Typography>
                <Stack spacing={2}>
                    <TextField select label="Typ" name="type" value={form.type} onChange={onFormChange} fullWidth>
                        {APPROVAL_TYPES.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        label="Referenz-ID"
                        name="targetId"
                        value={form.targetId}
                        onChange={onFormChange}
                        required
                        fullWidth
                        helperText="ID des zu prüfenden Vorgangs"
                    />
                    <TextField
                        label="Kommentar"
                        name="comment"
                        value={form.comment}
                        onChange={onFormChange}
                        fullWidth
                        multiline
                        minRows={3}
                    />
                    <Button type="submit" variant="contained" color="primary">
                        Freigabe anfordern
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
}
